import {
  DEFAULT_BLOG_IMG_PLACEHOLDER,
  VIDEO_BASE_URL
} from "../constants";

class VideoUploadUtils {

  buildVideoSrc = (video: string | undefined | null): string | undefined => {
    return video ? `${VIDEO_BASE_URL.BASE}/${video}` : DEFAULT_BLOG_IMG_PLACEHOLDER;
  };

  convertImgServerSrc = (
    videoSrc: string,
    videoType: "video"
  ): string => {
    let serverSrc: string = "";

    switch (videoType) {
      case "video":
        serverSrc = videoSrc.replace(`${VIDEO_BASE_URL.BASE}/`, "");
        break;

      default:
        break;
    }

    return serverSrc;
  };
}

export const VideoUploadUtil = new VideoUploadUtils();
